export default __webpack_public_path__ + "static/media/Pot3.a931b765.svg";